import React from 'react';
import gql from 'graphql-tag';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import Editor from '../../../../../modules/react/editors/Mapbox';

const GET_FACILITIES = gql`
  query GetFacilitiesMapData($filter: FacilitiesFilterInput!) {
    facilities(filter: $filter) {
      edges {
        node {
          id
          location {
            coordinates
          }
        }
      }
    }
  }
`;

const propTypes = {};
const defaultProps = {};

const EditorContainer = ({ pageFacilityId, ...rest }) => {
  const { data } = useQuery(GET_FACILITIES, { variables: { filter: { live: true } } });

  if (!data) {
    return null;
  }

  return (
    <Editor
      multiFacility
      {...rest}
      facilities={data.facilities.edges.map(edge => edge.node)}
      primaryFacilityId={pageFacilityId}
    />
  );
};

EditorContainer.propTypes = propTypes;
EditorContainer.defaultProps = defaultProps;

export default EditorContainer;
